// https://api-publica.speedio.com.br/buscarcnpj?cnpj=10831068000176
import axios from "axios";

export async function getCNPJ(cnpj: string) {
  const { data } = await axios.get(
    `https://api-publica.speedio.com.br/buscarcnpj?cnpj=${cnpj}`
  );
  return data;
}
